export default class User{
  name = null;
  username= null;
  email=null;
  division=null;
  organization={
    name: null,
    address: null,
    province: {
      code: null,
      name: null,
    },
    city: {
      code: null,
      name: null,
    },
  }
}
